export interface Germinador {
  id: number;
  laboratorio_id: number;
  minima_temperatura: number; //double(2)
  maxima_temperatura: number; //double(2)
  tiene_alternancia_temperatura: boolean;
  tiene_alternancia_luz: boolean;
}

export function createEmptyGerminador(): Germinador {
  return {
    id: null,
    laboratorio_id: null,
    minima_temperatura: null,
    maxima_temperatura: null,
    tiene_alternancia_temperatura: null,
    tiene_alternancia_luz: null
  };
}

export function createGerminador(params: any): Germinador {
  return {
    ...createEmptyGerminador(),
    ...params
  };
}
